<template>
  <section class="grid-view">
    <multi-card-loader v-if="loader" />
    <b-row v-else>
      <b-col
        md="8"
        sm="12"
        offset-md="2"
      >
        <b-card>
          <b-card-title>
            {{ $t('Send Quick Message') }}
          </b-card-title>
          <b-card-body>
            <validation-observer
              ref="saveCampaignName"
              #default="{ invalid }"
            >
              <b-row>
                <b-col md="12">
                  <b-form-group>
                    <validation-provider
                      #default="{ errors }"
                      :name="$t('Accounts')"
                      vid="Accounts"
                      rules="required"
                    >
                      <v-select
                        v-model="selectedAccount"
                        label="name"
                        :options="accounts"
                        :state="errors.length > 0 ? false : null"
                        :placeholder="$t('Accounts')"
                      >
                        <template #option="{ name }">
                          <span> {{ name }}</span>
                        </template>
                      </v-select>
                      <small class="text-danger">{{ errors[0] }}</small>
                      <small class="text-success">{{
                        $t('Select one account to send messages')
                      }} ...</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col
                  v-if="selectedAccount"
                  md="12"
                >
                  <send-test-message :account="selectedAccount" />
                </b-col>
              </b-row>
            </validation-observer>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BCardTitle,
  BFormGroup,

} from 'bootstrap-vue'
import SendTestMessage from '../../components/accounts/SendTestMessage'
import MultiCardLoader from '../../components/loaders/MultiCardLoader'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BCardTitle,
    BFormGroup,
    vSelect,
    MultiCardLoader,
    ValidationProvider,
    ValidationObserver,
    SendTestMessage,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      loader: true,
      accounts: null,
      selectedAccount: null,
      required,
    }
  },
  created() {
    this.getData()
  },

  methods: {
    getData() {
      this.$http
        .get('accounts', {
          params: {
            me: 1,
            active: 1,
          },
        })
        .then(({ data }) => {
          this.loader = false
          this.accounts = data.items
        })
        .catch(() => {
          this.loader = false
        })
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
